import { create } from 'zustand';
import { RSOTypeValue, SubTypeValue, RSOTypeKey, rsoType, subType } from '@graphic/types';

import { immer } from 'zustand/middleware/immer';
import { devtools } from 'zustand/middleware';

// import { FilterType } from '@/types';

type FilterStore = {
  filters: any[];
  toggleMainFilter: (filterName: RSOTypeValue) => void;
  toggleSubFilter: (filterName: RSOTypeValue, subFilterName: SubTypeValue) => void;
  setAll: (enable: boolean) => void;
  isEnable: (subType: SubTypeValue) => boolean;
};

const initialState = {
  filters: [
    {
      name: rsoType.PAYLOAD,
      subFilters: [
        { name: subType.STARLINK, enabled: true },
        { name: subType.ONEWEB, enabled: true },
        { name: subType.OTHERS, enabled: true },
      ],
      enabled: true,
    },
    {
      name: rsoType.ROCKET_BODY,
      subFilters: [{ name: subType.ROCKET_BODY, enabled: false }],
      enabled: false,
    },
    {
      name: rsoType.DEBRIS,
      subFilters: [{ name: subType.DEBRIS, enabled: false }],
      enabled: false,
    },
    {
      name: rsoType.UNKNOWN,
      subFilters: [{ name: subType.UNKNOWN, enabled: false }],
      enabled: false,
    },
  ],
};

export const useFilterStore = create<FilterStore>()(
  immer((set, get) => ({
    ...initialState,
    toggleMainFilter: (filterName: RSOTypeValue) => {
      set((state) => {
        state.filters.forEach((filter) => {
          if (filter.name === filterName) {
            filter.enabled = !filter.enabled;

            filter.subFilters.forEach((subFilter) => {
              subFilter.enabled = filter.enabled;
            });
          }
        });
      });
    },

    toggleSubFilter: (filterName, subFilterName) => {
      set((state) => {
        const mainFilter = state.filters.find((filter) => filter.name === filterName);
        const { subFilters } = mainFilter;
        const subFilter = subFilters.find((subFilter) => subFilter.name === subFilterName);

        subFilter.enabled = !subFilter.enabled;

        const isDisabled = subFilters.some((subFilter) => !subFilter.enabled);

        mainFilter.enabled = !isDisabled;
      });
    },
    setAll: (enable) => {
      set((state) => {
        state.filters.forEach((filter) => {
          filter.subFilters.forEach((subFilter) => {
            subFilter.enabled = enable;
          });
          filter.enabled = enable;
        });
      });
    },
    isEnable: (subType) => {
      const filters = get().filters;
      let enable = false;
      filters.forEach((filter) => {
        filter.subFilters.forEach((subFilter) => {
          if (subFilter.name === subType) {
            enable = subFilter.enabled;
          }
        });
      });
      return enable;
    },
  }))
);
